module.exports = __webpack_public_path__ + "assets/img/dzxwq.8417001d.png";